import { render, staticRenderFns } from "./PainelPacientes.vue?vue&type=template&id=95624194&"
import script from "./PainelPacientes.vue?vue&type=script&lang=js&"
export * from "./PainelPacientes.vue?vue&type=script&lang=js&"
import style0 from "./PainelPacientes.vue?vue&type=style&index=0&id=95624194&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports